// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Theme Styles === */

/* Brand Colors */
:root {
    --primary-color: #222;
    --accent-color: #f8d31c;
    --text-color: #333;
    --bg-color: #fff;
  }
  
  /* Typography */
  h1, h2, h3, h4 {
    color: var(--primary-color);
    font-family: 'Poppins', sans-serif;
  }
  
  a {
    color: var(--primary-color);
    text-decoration: none;
  }
  
  a:hover {
    color: var(--accent-color);
  }
  
  /* Buttons */
  button {
    font-family: inherit;
    border: none;
    cursor: pointer;
    transition: background 0.3s ease;
  }
  
  button:hover {
    opacity: 0.9;
  }
  
  /* Add-to-cart button override */
.btn-add {
  padding: 10px;
  background-color: var(--pure-white);
  border: 1px solid #979cdb;
  color: rgb(0, 0, 0);
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 15px;
  width: 50%; 
  align-self: center;              /* <-- Key line */
  display: inline-block;     /* <-- Prevent it from taking full width */
}

.btn-add:hover {
  background-color: var(--primary-hover);
  color: aqua;
}

  
  /* Checkout */
  .btn-checkout {
    background-color: #28a745;
    color: white;
  }
  
  .btn-checkout:hover {
    background-color: #218838;
  }
  
  /* Remove button */
 

  
  /* Cart indicator */
  .nav-cart {
    position: relative;
    font-weight: bold;
  }
  
  .nav-cart::after {
    content: '';
    position: absolute;
    top: -5px;
    right: -10px;
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
  }


 @media (max-width: 480px) {
    
  .btn-add {
  padding: 10px;
  background-color: var(--pure-white);
  border: 1px solid #979cdb;
  color: rgb(0, 0, 0);
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 15px;
  width: 100%; 
  align-self: center;            
  display: inline-block;     
}


 }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.3);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,iBAAiB;AACjB;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,YAAY;EACZ;IACE,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA,gCAAgC;AAClC;EACE,aAAa;EACb,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB,eAAe,iBAAiB;EAClD,qBAAqB,MAAM,0CAA0C;AACvE;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;;EAGE,aAAa;EACb;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;;;;EAIlB,mBAAmB;EACnB;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,8BAA8B;EAChC;;;CAGD;;EAEC;EACA,aAAa;EACb,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;;CAGC;;EAEC;IACE;MACE,mBAAmB;MACnB,UAAU;IACZ;IACA;MACE,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF","sourcesContent":["/* === Theme Styles === */\n\n/* Brand Colors */\n:root {\n    --primary-color: #222;\n    --accent-color: #f8d31c;\n    --text-color: #333;\n    --bg-color: #fff;\n  }\n  \n  /* Typography */\n  h1, h2, h3, h4 {\n    color: var(--primary-color);\n    font-family: 'Poppins', sans-serif;\n  }\n  \n  a {\n    color: var(--primary-color);\n    text-decoration: none;\n  }\n  \n  a:hover {\n    color: var(--accent-color);\n  }\n  \n  /* Buttons */\n  button {\n    font-family: inherit;\n    border: none;\n    cursor: pointer;\n    transition: background 0.3s ease;\n  }\n  \n  button:hover {\n    opacity: 0.9;\n  }\n  \n  /* Add-to-cart button override */\n.btn-add {\n  padding: 10px;\n  background-color: var(--pure-white);\n  border: 1px solid #979cdb;\n  color: rgb(0, 0, 0);\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 15px;\n  width: 50%; \n  align-self: center;              /* <-- Key line */\n  display: inline-block;     /* <-- Prevent it from taking full width */\n}\n\n.btn-add:hover {\n  background-color: var(--primary-hover);\n  color: aqua;\n}\n\n  \n  /* Checkout */\n  .btn-checkout {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  .btn-checkout:hover {\n    background-color: #218838;\n  }\n  \n  /* Remove button */\n \n\n  \n  /* Cart indicator */\n  .nav-cart {\n    position: relative;\n    font-weight: bold;\n  }\n  \n  .nav-cart::after {\n    content: '';\n    position: absolute;\n    top: -5px;\n    right: -10px;\n    width: 8px;\n    height: 8px;\n    background: red;\n    border-radius: 50%;\n    animation: pulse 1.5s infinite;\n  }\n\n\n @media (max-width: 480px) {\n    \n  .btn-add {\n  padding: 10px;\n  background-color: var(--pure-white);\n  border: 1px solid #979cdb;\n  color: rgb(0, 0, 0);\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 15px;\n  width: 100%; \n  align-self: center;            \n  display: inline-block;     \n}\n\n\n }\n  \n  @keyframes pulse {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    50% {\n      transform: scale(1.3);\n      opacity: 0.5;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
